<template>
  <b-link class="popover-info" tabindex="0" :id="popid" data-toggle="popover" style="border:none">
    <InfoIcon />
    <b-popover :target="popid" triggers="focus">{{text}}</b-popover>
  </b-link>
</template>

<script>
import { InfoIcon } from "vue-feather-icons";

export default {
  name: "InfoPopup",
  components: {
    InfoIcon
  },
  props: {
    text: { type: String, default: "" },
    popid: { type: String, default: "" }
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$three-to-one-gray: #939393;
svg.feather {
  color: $three-to-one-gray;
}

.popover-info:hover,
.popover-info:focus {
  color: #444;
  background: transparent;
  border: none;
  outline: none;
}
</style>
